module.exports = __webpack_public_path__ + "static/media/teacher_view_navigate_video.6c625763.mov";